import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ToastControllerWrapperService {

  toast: any;

  constructor(private toastController: ToastController) { }

  async display(message: string): Promise<void> {

    try {
      this.toast.dismiss();
    } catch (erro) {}

    this.toast = await this.toastController.create({
      message: message,
      position: 'top',
      buttons: [
        {
          text: 'Hide',
          side: 'end',
          role: 'cancel'
        }
      ],
      duration: environment.TOAST_DEFAULT_DURATION
    });
    return this.toast.present();
  }

  async success(message: string): Promise<void> {

    try {
      this.toast.dismiss();
    } catch (erro) {}

    this.toast = await this.toastController.create({
      message: message,
      icon: 'checkmark',
      position: 'top',
      color: 'success',
      buttons: [
        {
          text: 'Hide',
          side: 'end',
          role: 'cancel'
        }
      ],
      duration: environment.TOAST_SUCCESS_DEFAULT_DURATION
    });
    return this.toast.present();
  }

  async presentErrorToast(message: string): Promise<void> {

    try {
      this.toast.dismiss();
    } catch (erro) {}

    this.toast = await this.toastController.create({
      message: message,
      icon: 'warning',
      color: 'danger',
      position: 'top',
      buttons: [
        {
          text: 'Hide',
          side: 'end',
          role: 'cancel'
        }
      ],
      duration: environment.TOAST_ERROR_DEFAULT_DURATION
    });
    return this.toast.present();
  }

  async dismissToast(): Promise<boolean> {
    if (!this.toast) return;
    return await this.toast.dismiss();
  }

}
